export const isAuthenticated = (auth: {
  accessToken: string;
  expiresAt: number;
}): boolean => {
  return auth.accessToken !== '' && auth.expiresAt > Date.now();
};

export default isAuthenticated;
